export const TIPO_ARTICULO = {
  SERVICIO: 0,
  PRODUCTO: 1,
} as const

export type TipoArticuloType =
  (typeof TIPO_ARTICULO)[keyof typeof TIPO_ARTICULO]
